module.exports = __webpack_public_path__ + "static/img/2017-04-08 15-42 44.c16210f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2017-04-08 15-42 44.jpg
// module id = yb52
// module chunks = 4